export enum MeasureSystemType {
    IMPERIAL = "IMPERIAL",
    METRIC = "METRIC",
}
